import React, { useRef } from 'react'
import { connect } from 'react-redux'
import { Tabs, Tab, Button } from 'react-bootstrap'

import { addICUAdmission } from '../reducers/antibioticsUseFormReducer'
//
import ICUAdmission from './ICUAdmission'

const ICUAdmissionList = (props) => {
  const { icuAdmissions, chartForReview } = props

  const tabsRef = useRef()

  const handleAddICUAdmissionClick = () => {
    const icuAdmissionNumber = icuAdmissions.length + 1
    props.addICUAdmission(icuAdmissionNumber)
    const topOffset = window.pageYOffset
    const clientRect = tabsRef.current.getBoundingClientRect()
    const clientLocation = window.innerHeight / 4
    const scrollToLocation = topOffset + clientRect.top - clientLocation
    window.scrollTo({
      top: scrollToLocation,
      left: 0,
      behavior: 'smooth',
    })
    props.alert.success(`ICU Admission ${icuAdmissionNumber} has been added`)
  }

  return (
    <div ref={tabsRef}>

      <br/>

      <Tabs defaultActiveKey={0} transition={false}>

        {icuAdmissions.map((icuAdmission, index) => {
          return (
            <Tab
              eventKey={index}
              title={`ICU Admission ${index + 1}`}
              key={`icu-admission-${index + 1}`}
            >
              <ICUAdmission
                chartForReview={chartForReview}
                icuAdmissions={icuAdmissions}
                {...icuAdmission}
              />
            </Tab>
          )
        })}
      </Tabs>

      <br/>

      {chartForReview ?
        null
        :
        <center>
          <Button
            onClick={handleAddICUAdmissionClick}
          >
            Add ICU Admission
          </Button>
        </center>
      }

      <br/>
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    icuAdmissions: state.antibioticsUseFormReducer.icuAdmissions,
  }
}

const mapDispatchToProps = {
  addICUAdmission,
}

export default connect(mapStateToProps, mapDispatchToProps)(ICUAdmissionList)
